import { useEffect, useRef, useState } from "react";

// Custom Compnent
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Image
import binRed from "../../assets/images/bin_red.svg";
import { PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../constants/const";

// Styles
import "./styles.scss";

const TimerCircle = (props) => {
  const [timer_progress, settimer_progress] = useState(0);
  const [path_color, setpath_color] = useState("#ffffff");
  const timerCircleInterval = useRef()

  let step = 100 / Number(props.time);

  const timeoutTrigger = () => {
    timerCircleInterval.current = setInterval(() => {
      if (timer_progress >= 100) {
      } else {
        settimer_progress(progress => progress + step);
      }
    }, 1000);
  };

  const handlePauseTimer = () => {
    clearInterval(timerCircleInterval.current)
  }

  useEffect(() => {
    if (timer_progress >= 33 && timer_progress < 83) {
      setpath_color("#65E261");
    } else if (timer_progress >= 83) {
      setpath_color("#E53244");
    }
  }, [timer_progress])

  useEffect(() => {
    if (props.start) {
      timeoutTrigger()
    }
    return () => clearInterval(timerCircleInterval.current)
  }, [props.start])

  useEffect(() => {
    window.addEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, timeoutTrigger)
    return () => {
      window.removeEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
      window.removeEventListener(RESUME_TIMER_EVENT, timeoutTrigger)
    }
  }, [])

  return (
    <div className="timerCircle-root">
      <div className="circle">
        <CircularProgressbarWithChildren
          styles={{
            path: { stroke: path_color },
            trail: { stroke: "#171717" },
          }}
          strokeWidth={15}
          value={timer_progress}
        >
          {timer_progress >= 83 && <img className="bin-img" src={binRed} alt="" />}
        </CircularProgressbarWithChildren>
      </div>
    </div>
  );
};

export default TimerCircle;
